<mon-statistics-page-scaffold [config]="activeConfig">
    <div siteAnalyticsScaffoldBeforeControls>
        <p-tabs
            [value]="activeTab"
            (valueChange)="onTabChange($event)"
            class="tw-mb-4"
            data-test="site-analytics-events-tabs"
            [ariaLabel]="'siteAnalytics.events.tabs.ariaLabel' | transloco"
        >
            <p-tablist data-test="site-analytics-events-tabs-list">
                @for (tab of tabs; track tab.value) {
                    <p-tab [value]="tab.value" data-test="site-analytics-events-tabs-list-item">
                        {{ tab.labelKey | transloco }}
                    </p-tab>
                }
            </p-tablist>
        </p-tabs>
    </div>
</mon-statistics-page-scaffold>
